<script>
  export let width = 4;
  export let height = 40;
  export let fill = 0;
</script>

<div class="line" style="height: {height}px; width: {width}px;">
  {#if fill > 0}
    <div class="fill" style="height: {fill * 100}%;" />
  {/if}
</div>

<style>
  .line {
    border-radius: 4px;
    background-color: white;
    position: relative;
    overflow: hidden;
  }

  .fill {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: var(--rekki-success);
  }
</style>
